<div class="flex flex-col vdd-row">
  <ng-container *ngTemplateOutlet="desktopView"></ng-container>
  <ng-container *ngTemplateOutlet="mobileView"></ng-container>
</div>

<ng-template #desktopView>
  <div class="xs:!hidden">
    <div class="flex flex-row justify-start items-center flex-[15%] max-w-[15%]">
      {{ vdd.id }}
    </div>
    <div class="word-break flex flex-row justify-start items-center flex-[35%] max-w-[35%]">
      <div class="flex flex-col justify-center items-start">
        <div>{{ 'TI_' + vdd.feature | translate }}</div>
        <small data-at-vdd-name>{{ vdd.feature }}</small>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="loading"></ng-container>
  </div>
</ng-template>

<ng-template #mobileView>
  <div
    class="vdd-item !hidden xs:!flex flex-row"
    *ngFor="let vddItem of vddItems; let isLast = last"
    [class.last]="isLast"
  >
    <div class="title flex-[50%] max-w-[50%]">{{ this.getItemTitleTranslationKey(vddItem) }}</div>
    <div class="parameter flex-[50%] max-w-[50%]">
      <div *ngIf="vdd[vddItem]; else loading">
        {{ vdd[vddItem] }}
      </div>
    </div>
  </div>
</ng-template>

<ng-template #loading>
  <div
    *ngIf="isVddLoading; else vddLoaded"
    class="flex flex-row justify-center items-center flex-[100%] max-w-[50%]"
  >
    <mat-spinner></mat-spinner>
  </div>
</ng-template>

<ng-template #vddLoaded>
  <div class="xs:flex-[100%] xs:max-w-[100%] gt-xs:flex-[50%] gt-xs:max-w-[50%]">
    <div
      class="gt-xs:flex gt-xs:flex-col gt-xs:justify-center gt-xs:items-center"
      *ngIf="matchedValues?.length; else readError"
    >
      <div
        data-at-structure-value
        *ngFor="let matchedValue of matchedValues"
        class="full-width vdd-value flex gt-xs:flex-row xs:flex-col"
      >
        <span class="gt-xs:flex-[40%] gt-xs:max-w-[40%]"
          >{{ matchedValue.translationid | translate }}
          <span *ngIf="matchedValue.value">:</span></span
        >
        <span *ngIf="matchedValue.value" class="gt-xs:flex-[60%] gt-xs:max-w-[60%]"
          >{{ matchedValue.value | decimalPipe }} {{ ' ' }} {{ matchedValue.unit }}</span
        >
      </div>
    </div>
    <ng-template #readError>
      <vi-alert>
        <strong>{{ 'DIAGNOSTICS.VDD_CANNOT_BE_DISPLAYED' | translate }}</strong>
      </vi-alert>
    </ng-template>
  </div>
</ng-template>
